type TDividerProps = {
  className?: string;
};

export function Divider({ className }: TDividerProps) {
  return <div className={`clear-both flex h-[1px] w-full min-w-full border-t border-[var(--color-divider)] text-base ${className}`} />;
}
